export enum BannerTypes {
  ACCEPTED = 'accepted',
  ALTERNATE_APPROACH = 'alternate_approach',
  DATA_AVAILABLE = 'available',
  IN_REVIEW = 'inReview',
  SUBMISSION_CLOSED = 'submission_closed',
  VALIDATION_OPEN = 'validation_open',
}

export const BannerMessages: Record<BannerTypes, string> = {
  [BannerTypes.ACCEPTED]:
    'This grant has been accepted for the current reporting year.',
  [BannerTypes.ALTERNATE_APPROACH]:
    'This grant does not currently require data to be imported via our Data Upload feature.',
  [BannerTypes.DATA_AVAILABLE]: '',
  [BannerTypes.IN_REVIEW]:
    'This grant is currently under review. You will not be able to make any changes during this time.',
  [BannerTypes.SUBMISSION_CLOSED]: '',
  [BannerTypes.VALIDATION_OPEN]: '',
};
